/* Funtastic — página de produto e carrinho: compra, barra fixa, painel do carrinho e extras de 1 toque */
(function(){
  'use strict';
  if (window.__fsPdp) return; window.__fsPdp = 1;
  var FS = window.FS = window.FS || {};
  var ES = (document.documentElement.lang || 'pt').slice(0,2) === 'es';
  var SEC = 'fs-cart-drawer';
  var PLATE = 'Matrícula personalizada';
  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(url, body){
    return fetch(root() + url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || (ES ? 'No se pudo añadir.' : 'Não foi possível juntar.')); return j; }); });
  }

  /* ---------- Painel do carrinho ---------- */
  var cd = null, lastFocus = null, loaded = false, busy = false;
  function drawer(){ if (!cd) cd = $('[data-fs-cartdrawer]'); return cd; }
  function bodyEl(){ var d = drawer(); return d ? $('[data-fs-cd-body]', d) : null; }
  function setTitle(added){
    var t = $('[data-fs-cd-title]', drawer()); if (!t) return;
    if (added){ t.innerHTML = '<span class="fs-cd__ok" aria-hidden="true">✓</span>' + t.getAttribute('data-t-added'); }
    else t.textContent = t.getAttribute('data-t-cart');
  }
  function updateCount(n){
    $$('a[href$="/cart"], a[href*="/cart?"], [data-fs-open-cart]').forEach(function(a){
      if (a.closest('[data-fs-cartdrawer]') || a.closest('[data-fs-cart-body]')) return;
      var b = $('.fs-badge', a);
      if (n > 0){ if (!b){ b = document.createElement('span'); b.className = 'fs-badge'; a.appendChild(b); } b.textContent = n; }
      else if (b) b.remove();
    });
  }
  function paint(html, addedId){
    var b = bodyEl(); if (!b || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-fs-cart-body]'); if (!fresh) return;
    b.innerHTML = ''; b.appendChild(document.importNode(fresh, true));
    loaded = true;
    var nb = $('[data-fs-cart-body]', b);
    if (addedId){
      var line = $('.fs-cl[data-variant="' + addedId + '"]', nb);
      if (line){ line.classList.add('is-added'); var list = line.parentNode; list.insertBefore(line, list.firstChild); }
    }
    if (FS.initCommon) FS.initCommon(nb);
    var n = parseInt(nb.getAttribute('data-count'), 10) || 0;
    updateCount(n);
    document.dispatchEvent(new CustomEvent('fs:cart:updated', {detail:{count:n}}));
  }
  function load(){
    return fetch(location.pathname + '?section_id=' + SEC, {credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(h){ paint(h); });
  }
  function open(added){
    var d = drawer(); if (!d) { location.href = root() + 'cart'; return; }
    lastFocus = document.activeElement;
    setTitle(!!added);
    d.hidden = false; d.setAttribute('aria-hidden', 'false');
    void d.offsetWidth; d.setAttribute('data-open', '');
    document.documentElement.classList.add('fs-cd-lock');
    var p = $('.fs-cd__panel', d); if (p) setTimeout(function(){ p.focus({preventScroll:true}); }, 60);
    if (!added) load();
  }
  function close(){
    var d = drawer(); if (!d || d.hidden) return;
    d.removeAttribute('data-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fs-cd-lock');
    setTimeout(function(){ if (!d.hasAttribute('data-open')) d.hidden = true; }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  FS.openCart = function(){ open(false); };
  FS.closeCart = close;
  FS.refreshCart = load;

  function inDrawer(el){ return !!(el && el.closest && el.closest('[data-fs-cartdrawer]')); }
  function pageBody(el){ return el && el.closest && el.closest('.fs-cb--page'); }
  function afterChange(el, j, addedId){
    if (inDrawer(el)) paint(j && j.sections && j.sections[SEC], addedId);
    else window.location.reload();
  }
  function lock(el, on){ if (!el) return; el.disabled = on; if (on) el.setAttribute('aria-busy','true'); else el.removeAttribute('aria-busy'); }
  function cartErr(el, msg){
    var host = el.closest('[data-fs-cart-body]'); if (!host) { alert(msg); return; }
    var n = $('.fs-cb__err', host);
    if (!n){ n = document.createElement('p'); n.className = 'fs-cb__err'; n.setAttribute('role','alert'); host.insertBefore(n, host.firstChild); }
    n.textContent = msg;
  }

  /* ---------- Comprar ---------- */
  function add(btn){
    var model = btn.closest('[data-fs-model]') || $('[data-fs-model]'); if (!model) return;
    var form = $('[data-fs-buy2]', model); if (!form) return;
    var sel = $('[name=id]', form), err = $('[data-fs-buy-err]', model);
    if (!sel || !sel.value){
      var target = sel || form; target.scrollIntoView({block:'center', behavior:'smooth'}); if (sel && sel.focus) sel.focus({preventScroll:true});
      if (err){ err.hidden = false; err.textContent = ES ? 'Elija una opción antes de comprar.' : 'Escolha uma opção antes de comprar.'; }
      return;
    }
    if (err) err.hidden = true;
    var props = {}, plate = $('[data-fs-plate] input', model);
    if (plate && plate.value.trim()) props[plate.getAttribute('data-prop') || PLATE] = plate.value.trim();
    var vid = +sel.value, btns = $$('[data-fs-add]', model);
    if (busy) return; busy = true;
    btns.forEach(function(b){ lock(b, true); });
    post('cart/add.js', {items:[{id:vid, quantity:1, properties:props}], sections:SEC, sections_url:location.pathname})
      .then(function(j){
        if (drawer()){ paint(j.sections && j.sections[SEC], vid); open(true); }
        else window.location.href = root() + 'cart';
      })
      .catch(function(e){ if (err){ err.hidden = false; err.textContent = e.message; err.scrollIntoView({block:'center', behavior:'smooth'}); } else alert(e.message); })
      .then(function(){ busy = false; btns.forEach(function(b){ lock(b, false); }); });
  }

  /* ---------- Cliques ---------- */
  document.addEventListener('click', function(e){
    var t = e.target;
    var a = t.closest('[data-fs-add]');
    if (a){ e.preventDefault(); add(a); return; }
    var oc = t.closest('[data-fs-open-cart]');
    if (oc && drawer()){ e.preventDefault(); open(false); return; }
    var c = t.closest('[data-fs-cd-close]');
    if (c && inDrawer(c)){ if (c.tagName !== 'A') e.preventDefault(); close(); return; }

    /* Quantidades e retirar (no /cart trata o fs.js) */
    var q = t.closest('[data-q]');
    if (q && inDrawer(q)){
      e.preventDefault(); lock(q, true);
      post('cart/change.js', {line:+q.getAttribute('data-line'), quantity:Math.max(0, +q.getAttribute('data-q')), sections:SEC, sections_url:location.pathname})
        .then(function(j){ afterChange(q, j); }).catch(function(er){ lock(q, false); cartErr(q, er.message); });
      return;
    }
    /* Extras: abrir campo */
    var xo = t.closest('[data-fs-x-open]');
    if (xo){
      e.preventDefault();
      var row = xo.closest('.fs-x'), more = row && $('.fs-x__more', row);
      if (more){ more.hidden = false; xo.hidden = true; var inp = $('input', more); if (inp){ inp.focus(); inp.select(); } }
      return;
    }
    /* Extras: juntar com 1 toque */
    var x = t.closest('[data-fs-x]');
    if (x){
      e.preventDefault();
      var item = {id:+x.getAttribute('data-fs-x'), quantity:1};
      var prop = x.getAttribute('data-prop');
      if (prop){
        var field = $('input', x.closest('.fs-x'));
        var val = field ? field.value.trim() : '';
        if (!val){ if (field){ field.focus(); field.classList.add('is-err'); } return; }
        item.properties = {}; item.properties[prop] = val;
      }
      lock(x, true);
      post('cart/add.js', {items:[item], sections:SEC, sections_url:location.pathname})
        .then(function(j){ afterChange(x, j); }).catch(function(er){ lock(x, false); cartErr(x, er.message); });
      return;
    }
    /* Matrícula: editar no carrinho */
    var pe = t.closest('[data-fs-plate-edit]');
    if (pe){
      e.preventDefault();
      var f = $('.fs-cl__pform', pe.closest('[data-fs-plate-line]'));
      if (f){ f.hidden = !f.hidden; if (!f.hidden){ var i2 = $('input', f); i2.focus(); i2.select(); } }
      return;
    }
    var ps = t.closest('[data-fs-plate-save]');
    if (ps){
      e.preventDefault();
      var inp2 = $('[data-fs-plate-input]', ps.closest('.fs-cl__pform'));
      var v = (inp2 ? inp2.value : '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9 ]/g, '').trim().slice(0, 12);
      var pr = {}; try { pr = JSON.parse(ps.getAttribute('data-props') || '{}') || {}; } catch(er){}
      if (Array.isArray(pr)) pr = {};
      if (v) pr[PLATE] = v; else delete pr[PLATE];
      lock(ps, true);
      post('cart/change.js', {line:+ps.getAttribute('data-line'), quantity:+ps.getAttribute('data-qty') || 1, properties:pr, sections:SEC, sections_url:location.pathname})
        .then(function(j){ afterChange(ps, j); }).catch(function(er){ lock(ps, false); cartErr(ps, er.message); });
      return;
    }
  });
  document.addEventListener('input', function(e){
    var i = e.target;
    if (i.matches && i.matches('[data-fs-plate-input]')){
      var v = i.value.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, 12);
      if (i.value !== v) i.value = v;
    }
    if (i.classList && i.classList.contains('is-err')) i.classList.remove('is-err');
  });
  document.addEventListener('keydown', function(e){
    var d = drawer(); if (!d || d.hidden) return;
    if (e.key === 'Escape'){ close(); return; }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.fs-x__more input, [data-fs-plate-input]')){
      e.preventDefault(); var b = e.target.parentNode.querySelector('button'); if (b) b.click(); return;
    }
    if (e.key === 'Tab'){
      var f = $$('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])', d).filter(function(x){ return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]){ e.preventDefault(); f[f.length-1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length-1]){ e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.fs-cb--page .fs-x__more input, .fs-cb--page [data-fs-plate-input]')){
      e.preventDefault(); var b = e.target.parentNode.querySelector('button'); if (b) b.click();
    }
  });

  /* ---------- Avise-me: Klaviyo back in stock quando o Klaviyo está ativo (senão segue o formulário de contacto) ---------- */
  function klaviyoId(){ var sc = $('script[src*="klaviyo.js?company_id="]'); var m = sc && /company_id=([A-Za-z0-9]+)/.exec(sc.src); return m ? m[1] : null; }
  document.addEventListener('submit', function(e){
    var f = e.target; if (!f.matches || !f.matches('[data-fs-bis-form]')) return;
    var kid = klaviyoId(), vid = f.getAttribute('data-variant'); if (!kid || !vid) return;
    e.preventDefault();
    var em = ($('input[type=email]', f) || {}).value || '', btn = $('button', f); lock(btn, true);
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + kid, {method:'POST', headers:{'Content-Type':'application/json', revision:'2024-10-15'}, body:JSON.stringify({data:{type:'back-in-stock-subscription', attributes:{channels:['EMAIL'], profile:{data:{type:'profile', attributes:{email:em.trim()}}}}, relationships:{variant:{data:{type:'catalog-variant', id:'$shopify:::$default:::' + vid}}}}})})
      .then(function(r){ if (!r.ok) throw 0; f.innerHTML = '<p class="fs-note fs-note--ok">' + (ES ? 'Listo. Le avisaremos por email en cuanto vuelva.' : 'Feito. Avisamos por email assim que voltar.') + '</p>'; })
      .catch(function(){ lock(btn, false); HTMLFormElement.prototype.submit.call(f); });
  });

  /* ---------- Barra fixa: aparece quando a galeria sai do ecrã ---------- */
  var de = document.documentElement;
  function setSticky(st, on){
    if (!st) return;
    var was = st.hasAttribute('data-show');
    if (on === was) return;
    if (on){ st.setAttribute('data-show', ''); st.setAttribute('aria-hidden', 'false'); $$('[data-fs-add]', st).forEach(function(b){ b.removeAttribute('tabindex'); }); }
    else { st.removeAttribute('data-show'); st.setAttribute('aria-hidden', 'true'); $$('[data-fs-add]', st).forEach(function(b){ b.setAttribute('tabindex', '-1'); }); }
    document.body.classList.toggle('fs-has-sticky', on);
    de.style.setProperty('--fs-sticky-h', on ? st.offsetHeight + 'px' : '0px');
  }
  function initModel(m){
    if (!m || m._fsp) return; m._fsp = 1;
    var st = $('[data-fs-sticky2]', m), gal = $('[data-fs-gallery]', m), main = $('[data-fs-main-btn]', m), buy = $('[data-fs-buybox]', m);
    if (!('IntersectionObserver' in window)) return;
    var galOut = false, mainIn = false;
    function upd(){ setSticky(st, galOut && !mainIn && document.body.contains(m)); }
    if (gal) new IntersectionObserver(function(en){ en.forEach(function(x){ galOut = !x.isIntersecting && x.boundingClientRect.top < 0; }); upd(); }).observe(gal);
    if (main) new IntersectionObserver(function(en){ en.forEach(function(x){ mainIn = x.isIntersecting; }); upd(); }, {threshold:.6}).observe(main);
    if (buy) new IntersectionObserver(function(en){ en.forEach(function(x){ document.body.classList.toggle('fs-buybox-in-view', x.isIntersecting); }); }, {rootMargin:'-15% 0px -15% 0px'}).observe(buy);
    if (st) window.addEventListener('resize', function(){ if (st.hasAttribute('data-show')) de.style.setProperty('--fs-sticky-h', st.offsetHeight + 'px'); });
  }
  function scan(){
    $$('[data-fs-model]').forEach(function(m){
      initModel(m);
      var br = m.getAttribute('data-brand'), g = br && $('.at-ghost', m);
      if (g && g.textContent !== br) g.textContent = br;
      if (!m._bis && klaviyoId()){ m._bis = 1; $$('.fs-buy__mail', m).forEach(function(d){ d.open = true; }); }
    });
  }
  function boot(){
    de.style.setProperty('--fs-sticky-h', '0px');
    scan();
    var mainEl = document.getElementById('main') || document.body;
    if ('MutationObserver' in window) new MutationObserver(function(){ scan(); }).observe(mainEl, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', function(e){ if (e.persisted && loaded) load(); });
})();
